(function () {
  'use strict';
  function init(control) {
    if (control._wmSyncPicker) return;
    var options = Array.from(control.options);
    if (!options.length || !options.some(function (o) { return o.dataset.daw; })) return;
    var wrapper = control.parentElement;
    var card = control.closest('[data-pcard], [data-bundle-card]');
    var originalAdd = card && card.querySelector('[data-bundle-add], button[name="add"]');
    if (!originalAdd) return;
    var selectedValue = control.value;
    var dialog = document.createElement('dialog');
    dialog.className = 'wm-quick-shop';
    dialog.setAttribute('aria-label', 'Quick shop');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wm-quick-shop__close';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close quick shop');
    var title = document.createElement('h2');
    title.textContent = (card.querySelector('.wm-pcard__title, .wm-bcard__title') || {}).textContent || 'Choose your preset';
    var price = document.createElement('p');
    price.className = 'wm-quick-shop__price';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'wm-quick-shop__trigger';
    trigger.textContent = 'Quick shop';
    var confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = 'wm-quick-shop__confirm';
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'wm-quick-shop__remove';
    remove.textContent = 'Remove from bundle';
    var panel = document.createElement('div');
    panel.className = 'wm-card-picker';
    var label = document.createElement('label');
    label.className = 'wm-card-picker__label';
    label.appendChild(document.createTextNode('Your DAW'));
    var daw = document.createElement('select');
    daw.className = 'wm-card-picker__daw';
    var names = new Set();
    options.forEach(function (o) {
      if (names.has(o.dataset.daw)) return;
      names.add(o.dataset.daw);
      var item = document.createElement('option');
      item.value = o.dataset.daw;
      item.textContent = o.textContent.split(' · ')[0].trim();
      item.disabled = !options.some(function (v) { return v.dataset.daw === o.dataset.daw && !v.disabled; });
      daw.appendChild(item);
    });
    label.appendChild(daw);
    var versions = document.createElement('fieldset');
    versions.className = 'wm-card-picker__versions';
    var legend = document.createElement('legend');
    legend.textContent = 'Plugin version';
    versions.appendChild(legend);
    var buttons = document.createElement('div');
    buttons.className = 'wm-card-picker__buttons';
    versions.appendChild(buttons);
    var hint = document.createElement('p');
    hint.className = 'wm-card-picker__hint';
    hint.setAttribute('aria-live', 'polite');
    panel.append(label, versions, hint);
    dialog.append(close, title, price, panel, confirm, remove);
    wrapper.before(trigger, dialog);
    originalAdd.hidden = true;
    originalAdd.classList.add('wm-quick-shop__original-add');
    function added() { return card.classList.contains('is-added'); }
    trigger.addEventListener('click', function () {
      selectedValue = control.value;
      render();
      dialog.showModal();
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { trigger.focus({ preventScroll: true }); });
    dialog.addEventListener('keydown', function (event) { event.stopPropagation(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    confirm.addEventListener('click', function () {
      var option = options.find(function (o) { return o.value === selectedValue; });
      if (!option || option.disabled) return;
      var wasAdded = added();
      var changed = control.value !== selectedValue;
      control.value = selectedValue;
      if (changed) control.dispatchEvent(new Event('change', { bubbles: true }));
      dialog.close();
      if (!wasAdded) originalAdd.click();
    });
    remove.addEventListener('click', function () {
      if (added()) { dialog.close(); originalAdd.click(); }
    });
    wrapper.hidden = true;
    wrapper.classList.add('wm-card-picker__original');
    function commit(option) {
      if (!option || option.disabled) return;
      selectedValue = option.value;
      render();
    }
    function render() {
      var selected = options.find(function (o) { return o.value === selectedValue; });
      if (!selected) return;
      daw.value = selected.dataset.daw;
      price.textContent = selected.getAttribute('data-price-display') || '';
      confirm.textContent = added() ? 'Update selection' : 'Add to cart';
      confirm.disabled = selected.disabled;
      remove.hidden = !added();
      var choices = options.filter(function (o) { return o.dataset.daw === selected.dataset.daw && o.dataset.version; });
      var signature = choices.map(function (o) { return o.value; }).join(',');
      if (buttons.dataset.signature !== signature) {
        buttons.replaceChildren();
        choices.forEach(function (o) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'wm-card-picker__version';
          button.textContent = o.dataset.version;
          button.dataset.variant = o.value;
          button.disabled = o.disabled;
          button.addEventListener('click', function () { commit(o); });
          buttons.appendChild(button);
        });
        buttons.dataset.signature = signature;
      }
      Array.from(buttons.children).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.variant === selected.value)); });
      versions.hidden = choices.length === 0;
      var version = (selected.dataset.version || '').toLowerCase();
      hint.textContent = version === 'waves' ? 'Requires compatible Waves plugins.' : version === 'stock' ? 'Uses your DAW’s built-in plugins.' : '';
      hint.hidden = !hint.textContent;
    }
    daw.addEventListener('change', function () {
      var selected = options.find(function (o) { return o.value === selectedValue; });
      var choices = options.filter(function (o) { return o.dataset.daw === daw.value && !o.disabled; });
      commit(choices.find(function (o) { return selected && o.dataset.version === selected.dataset.version; }) || choices[0]);
    });
    control._wmSyncPicker = function () {
      if (!dialog.open) { selectedValue = control.value; render(); }
    };
    control.addEventListener('change', control._wmSyncPicker);
    render();
  }
  function boot() { document.querySelectorAll('select[data-pcard-daw], select[data-bundle-variant]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();
